export default function LoadError() {
    return <>Wystąpił błąd</>;
}
